/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import UnitMesurement from "../../components/UnitMesurement";

const AdminUnitMesurement = (props) => {
    return (
        <UnitMesurement moduleType={'Admin'} {...props} />
    )
}

export default AdminUnitMesurement